import React from 'react';
import SEOHead from '../components/SEOHead';
import { Shield, Lock, Eye, Database, Bell } from 'lucide-react';

const Privacy = () => {
  return (
    <>
      <SEOHead page="privacy" />
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        
        <div className="bg-white p-6 rounded-lg shadow-sm mb-8">
          <p className="text-gray-700">
            At Car Loan Payment Calculator, we respect your privacy and are committed to protecting your personal information.
            This privacy policy explains how we handle information when you use our car loan calculator tools.
          </p>
        </div>
        
        <div className="space-y-6 text-gray-700">
          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <Database className="h-6 w-6 text-blue-600 mr-3" />
              <h2 className="text-xl font-semibold">Information Collection</h2>
            </div>
            <p className="mb-2">
              We collect minimal information necessary to provide our car loan calculator services. 
              All calculations are performed locally in your browser, and we do not store 
              any of your loan calculation data on our servers.
            </p>
            <p>
              When you use our car loan calculator, the data you input (loan amount, interest rate, term, etc.) 
              remains on your device and is not transmitted to or stored on our servers.
            </p>
          </section>

          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <Lock className="h-6 w-6 text-blue-600 mr-3" />
              <h2 className="text-xl font-semibold">Data Storage</h2>
            </div>
            <p>
              Bookmarks and preferences are stored locally in your browser using localStorage. 
              This data remains on your device and is not transmitted to our servers, allowing you to save your 
              preferred car loan scenarios for future reference without privacy concerns.
            </p>
          </section>

          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <Eye className="h-6 w-6 text-blue-600 mr-3" />
              <h2 className="text-xl font-semibold">Cookies</h2>
            </div>
            <p>
              We use essential cookies to improve your experience when using our car loan calculator. 
              These cookies are necessary for the website to function properly and cannot be switched off. 
              They do not store personal information about your car loan calculations.
            </p>
          </section>

          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <Shield className="h-6 w-6 text-blue-600 mr-3" />
              <h2 className="text-xl font-semibold">Third-Party Services</h2>
            </div>
            <p>
              We may use third-party analytics services to improve our car loan calculator website. 
              These services may collect anonymous usage data in accordance with their own privacy policies, 
              but they do not have access to your specific car loan calculation inputs or results.
            </p>
          </section>

          <section className="bg-white p-6 rounded-lg shadow-sm">
            <div className="flex items-center mb-4">
              <Bell className="h-6 w-6 text-blue-600 mr-3" />
              <h2 className="text-xl font-semibold">Updates to Privacy Policy</h2>
            </div>
            <p>
              We may update this privacy policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons.
              Any changes will be posted on this page with an updated revision date.
            </p>
          </section>
          
          <div className="bg-blue-50 p-6 rounded-lg border border-blue-100 mt-8">
            <p className="text-blue-800">
              Last updated: {new Date().toLocaleDateString('en-AU', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
            <p className="mt-2 text-blue-800">
              If you have any questions about this Privacy Policy, please contact us through our Contact page.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Privacy;